import { ComponentsProps } from '@material-ui/core/styles/props';

const props: ComponentsProps = {
  MuiInputLabel: {
    shrink: true
  }
};

export default props;


// WEBPACK FOOTER //
// ./src/assets/theme/props.tsx